import { ActionReducer } from '@ngrx/store';
import { initialState, SEARCH_INCOMING_SOAP_ALERT_RECORDS, GET_INCOMING_SOAP_ALERT_RECORDS, RESET_INCOMING_SOAP_ALERT_GRID_DATA, RESET_INCOMING_SOAP_ALERT_RECORDS_TO_INITIAL_STATE } from './incoming_soap_alert.constant';
import { CLEAR_ALL_STORES_STATE, CustomAction } from '../index-store.constants';
import { IncomingSoapAlertState, IncomingSoapAlertFilterFields, ColumnOptions, GridConfiguration, IncomingSoapAlertRecordsSearchGridData } from './incoming_soap_alert.model';

export function incomingSoapAlertReducer(state: IncomingSoapAlertState = initialState, action: CustomAction) {
    switch (action.type) {
        case SEARCH_INCOMING_SOAP_ALERT_RECORDS:
            return {
                incomingSoapAlertFilterFields: action.payload,
                incomingSoapAlertRecordsSearchGridData: state.incomingSoapAlertRecordsSearchGridData
            };
        case GET_INCOMING_SOAP_ALERT_RECORDS:
            return {
                incomingSoapAlertFilterFields: state.incomingSoapAlertFilterFields,
                incomingSoapAlertRecordsSearchGridData: {
                    rowsPerPageOptions: state.incomingSoapAlertRecordsSearchGridData.rowsPerPageOptions,
                    cols: state.incomingSoapAlertRecordsSearchGridData.cols,
                    pageLinks: state.incomingSoapAlertRecordsSearchGridData.pageLinks,
                    rows: action.payload.rows,
                    configuration: action.payload.configuration,
                    filterData: action.payload.filterData,
                    totalRecords: action.payload.totalRecords
                }               
            };
        case RESET_INCOMING_SOAP_ALERT_GRID_DATA:
            return {
                incomingSoapAlertFilterFields: state.incomingSoapAlertFilterFields,
                incomingSoapAlertRecordsSearchGridData: initialState.incomingSoapAlertRecordsSearchGridData
            };
        case RESET_INCOMING_SOAP_ALERT_RECORDS_TO_INITIAL_STATE:
        case CLEAR_ALL_STORES_STATE:
            return {
                incomingSoapAlertFilterFields: {
                    patientName: "",
                    soapStatus: false
                },
                incomingSoapAlertRecordsSearchGridData: {
                    rows: 5,
                    rowsPerPageOptions: [5, 10, 20],
                    cols: [
                        { header: 'From', field: 'PATIENTNAME', sortable: true },
                        { header: 'Received On', field: 'DATEADDED', sortable: true },
                        { header: 'Patient Name', field: 'PATIENTNAME', sortable: true }
                    ],
                    pageLinks: 3,
                    configuration: {
                        page: 1,
                        pageSize: 5,
                        sort: "ALERT_ID",
                        order: 1
                    },
                    filterData: [],
                    totalRecords: 0
                }
            };
        default:
            return state;
    }
}
